import React from 'react';
import { motion } from 'framer-motion';

const About = () => {
  return (
    <motion.section
      initial={{ opacity: 0, x: -100 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ duration: 0.8 }}
      className="container mx-auto py-16"
    >
      <h2 className="text-4xl font-bold text-center mb-8">About Me</h2>
      <p className="text-lg text-gray-700 text-center max-w-2xl mx-auto">
        Hi, I'm [Your Name], a passionate event photographer based in the Bay Area. I specialize in capturing the essence of your special moments, from weddings to corporate events.
      </p>
    </motion.section>
  );
};

export default About;